export default function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_map.js
// module id = ../node_modules/ramda/es/internal/_map.js
// module chunks = 5